import styled from "styled-components/macro";

const CaseCardLabelOverflowStyled = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

export default CaseCardLabelOverflowStyled;
